import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import client from '../../api/client';
import IMG2 from '../../assets/images/stock-images/daniel-barnes-RKdLlTyjm5g-unsplash.jpg';
import IMG3 from '../../assets/images/stock-images/zion-c-sGblr5yVXiM-unsplash.jpg';
import { useAlert } from '../../context/AlertContext';
import seo, { services } from '../../data';
import ImageSlider from '../Global/ImageSlider';
import CoreValues from './CoreValues';
import GoogleMaps from './GoogleMaps';
import Services from './Services';

export default function About() {
	const [formData, setFormData] = useState({});
	const [disabled, setDisabled] = useState(true);
	const location = useLocation();
	const handleChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });

		if (formData?.email) {
			if (formData.email.includes('@') && formData.email.includes('.')) {
				setDisabled(false);
			} else {
				setDisabled(true);
			}
		}
	};

	const { setAlert } = useAlert();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisabled(true);

		try {
			const res = await client.post('/customer', {
				email: formData.email,
			});

			setFormData({});
			setAlert('success', 'Thank you for subscribing!');
		} catch (error) {
			console.error(error);
			setAlert('error', 'Error subscribing. Please try again.');
		}
	};

	const stats = [
		{ label: 'Years of Experience', value: '30+' },
		{ label: 'Customers', value: '185+' },
		{ label: 'Avg. Customer Feedback', value: '5/5' },
		{ label: 'Projects Completed', value: '500+' },
	];

	return (
		<main
			id='about'
			className='relative isolate bg-white pb-10'
		>
			{/* Header section */}
			<div className='px-6 pt-14 lg:px-8'>
				<div className='mx-auto max-w-2xl pt-24 text-center sm:pt-40'>
					<h1 className='text-5xl font-semibold tracking-tight text-black sm:text-7xl'>
						The USA BLINDS Commitment
					</h1>

					{seo.missionStatement.map((line, lineIdx) => (
						<p
							key={`mission-statement-${lineIdx}`}
							className='mt-8 text-pretty text-lg font-medium text-gray-600 sm:text-xl/8'
						>
							{line}
						</p>
					))}
				</div>
			</div>

			{/* Stats and content */}

			{location.pathname === '/' ? (
				<div className='mx-auto mt-20 max-w-7xl px-6 lg:px-8'>
					{/* <div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-none'>
						<dl className='mt-16 grid grid-cols-1 gap-x-8 gap-y-12 sm:mt-20 sm:grid-cols-2 sm:gap-y-16 lg:mt-28 lg:grid-cols-4'>
							{stats.map((stat, statIdx) => (
								<div
									key={statIdx}
									className='flex flex-col-reverse gap-y-3 border-l border-white/20 pl-6'
								>
									<dt className='text-base/7 text-gray-700'>{stat.label}</dt>
									<dd className='text-3xl font-semibold tracking-tight text-black'>
										{stat.value}
									</dd>
								</div>
							))}
						</dl>
					</div> */}
					<div className='mx-auto mt-20 max-w-7xl px-6 lg:px-8'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-none'>
							{seo.story.map((sentence, sentenceIdx) => {
								if (sentenceIdx < 1)
									return (
										<div
											key={sentenceIdx}
											className='flex flex-col-reverse gap-y-3 border-l border-white/20 pl-6'
										>
											<p className='mt-8 text-pretty text-lg font-light text-gray-800 sm:text-xl/8'>
												{sentence}
											</p>
										</div>
									);
							})}
						</div>
					</div>
					<Link
						to='/about'
						className='block text-center mt-10 text-primary-600 hover:text-primary-50'
					>
						Read More
					</Link>
				</div>
			) : (
				<div>
					<div className='mx-auto mt-20 max-w-7xl px-6 lg:px-8'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-none'>
							{seo.story.map((sentence, sentenceIdx) => {
								if (sentenceIdx >= 0)
									return (
										<div
											key={sentenceIdx}
											className='flex flex-col-reverse gap-y-3 border-l border-white/20 pl-6'
										>
											<p className='mt-8 text-pretty text-lg font-light text-gray-800 sm:text-xl/8'>
												{sentence}
											</p>
										</div>
									);
							})}
						</div>
					</div>
				</div>
			)}

			{/* Core Values */}
			<CoreValues />

			{/* Services section */}
			<Services services={services} />

			{/* CTA section */}
			<div className='my-20'>
				<GoogleMaps />
			</div>
			{/* Image section */}
			{/* <ImageSlider images={[IMG2, IMG3]} /> */}
		</main>
	);
}
